import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { captureGclidFromUrl } from "@/analytics/gclid";
import { App } from "./App";
import "@/styles/globals.css";

captureGclidFromUrl();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
